<template>
	<div>

    <header class="jumbo-page-header">
      <h1
        class="locator-title"
        id="aria-label_features"
        tabindex="-1"
        style="outline: none"
      >
        School Programs
      </h1>
      <p :style="{'font-size': 'small'}" class="locator-subtitle ml-4 pb-2">
        See what Mesa Public Schools has to offer.
      </p>
    </header>

		<main role="main">
			<div class="container px-3">
				<div class="categories" :key="index" v-for="(item, index) in categories" role="group" :aria-labelledby="'category-' + item.id">
					<h3 :id="'category-' + item.id">{{item.name}}</h3>
					<p>{{item.description}}</p>
					<hr>
					<div class="features" :key="index" v-for="(f, index) in item.features">
						<h4><i class="fa fa-check-circle fa-fw" aria-hidden="true"></i>{{ f.name }}</h4>
						<p>{{ f.description }}</p>
					</div>
				</div>
			</div>
		</main>

	</div>
</template>

<script>
	export default {
		props: ['categories'],
		data() {
			return {

			}
		},
		mounted() {
			document.querySelector('#aria-label_features').focus()
		}
	}
</script>

<style lang="scss" scoped>
  .categories {
  	margin-bottom: 3rem;
		h3 {
			font-size: 1.75rem;
			font-weight: 500;
	    color: rgb(68, 34, 102);
	    font-family: 'Montserrat', sans-serif;
		}
		> p {
			font-size: 1.25rem;
			margin: 0 0 1rem 0;
			font-family: 'Roboto', sans-serif;
		}
  }
  .features {
  	margin: 0 1rem;
		h4 {
			font-size: 1.25rem;
			color: rgb(68, 34, 102);
			font-family: 'Montserrat', sans-serif;
		}
		> p {
			font-size: 1rem;
			margin: 0 0 1rem 0;
			font-family: 'Roboto', sans-serif;
		}
  }
  @media screen and (min-width: 769px) {
  	.categories {
  		> p {
  			margin: 0 1rem 2rem 1rem;
  		}
  	}
  	.features {
  		margin: 0 2rem;
  		> p {
  			margin: 0 2rem 1rem 2rem;
  		}
  	}
  }
  @media screen and (min-width: 1024px) {
		.categories {
			h3 {
				font-size: 1.75rem;
			}
			> p {
				font-size: 1.35rem;
			}
		}
		.features {
			h4 {
				font-size: 1.35rem;
			}
			> p {
				font-size: 1.15rem;
			}
		}
	}
</style>
